import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AWBService } from 'src/app/services/operations/awb.service';
import { MiscService } from 'src/app/services/misc/misc.service';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AddressBookService } from 'src/app/services/general/addressbook.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-awb-split',
    templateUrl: './awb-split.component.html',
    styleUrls: ['./awb-split.component.scss']
})

export class AwbSplitComponent implements OnInit {
    awbSplitForm: FormGroup;
    isFormSubmitted = false;
    industryTypeList: any[] = [];
    addressBookList: any[] = [];
    @Input() AwbNumber = new EventEmitter<string>();

    isSplitGenerated = false;
    private gridApi!: GridApi;
    private gridColumnApi!: ColumnApi;
    public context: any;
    defaultColDef = {
        filter: true,
        sortable: true,
        resizable: false,
        flex: 1,
        minWidth: 120,
    };

    gridOptions: GridOptions = {
        pagination: true,
        paginationPageSize: 5,
        domLayout: 'autoHeight',
    }

    columnDefs = [
        { headerName: 'Child Awb No', field: 'childawbnumber', pinned: 'left' },
        { headerName: 'Shipper Name', field: 'shippername' },
        { headerName: 'Consignee Name', field: 'consigneename' },
    ]

    rowData = [];

    onGridReady(params: GridReadyEvent) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        params.api.sizeColumnsToFit();
    }

    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private utilities: Utilities,
        private _fb: FormBuilder,
        private awbService: AWBService,
        private miscService: MiscService,
        private addressbookService: AddressBookService,
        private ngxLoaderService: NgxUiLoaderService,
        private titleService: Title

    ) { 
        titleService.setTitle('Air Way Bill');
        this.context = { componentParent: this } 
    }

    ngOnInit() {
        this.awbSplitForm = this._fb.group({
            ddlIndustryType: [null, Validators.compose([Validators.required])]
        });
        this.bindChildAwb();
    }

    bindChildAwb() {
        try {
            this.ngxLoaderService.start();
            this.awbService.GetChildAwb({ awbnumber: this.AwbNumber }).subscribe((res) => {
                if (res?.success) {
                    this.rowData = res.data;
                    this.bindIndustries();
                    this.ngxLoaderService.stop();
                }
            });
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
        }
    }

    bindIndustries() {
        try {
            this.miscService.GetAllIndustries().subscribe((res) => {
                if (res && res.success) {
                    this.industryTypeList = res.data;
                }
            });

        } catch (e) {
            console.error(e);
        }
    }

    generate() {
        try {
            this.isFormSubmitted = true;
            const industrytypeid = this.awbSplitForm.get('ddlIndustryType')?.value;
            if (industrytypeid) {
                this.addressbookService.GetAll({ industrytypeid: industrytypeid,isactive: true,customerid:null, countryisocode: this.appCoreService.GetUserData()?.metaInfo.defaultcountry }).subscribe((res) => {
                    if (res && res.success) {
                        this.addressBookList = res.data;

                        if (this.addressBookList.length < this.rowData.length) {
                            this.appCoreService.showMessage('Insufficient contacts.', 'Warning', 'warning');
                            return;
                        }
                        
                        let tempData: any[] = [];
                        const tempName: any = this.addressBookList.map((item: any) => ({
                            id: item.id,
                            name: item.name
                        }));

                        for (let i = 0, j = 0; i < this.rowData.length * 2; i = i + 2, j++) {
                            tempData.push({
                                childawbnumber: this.rowData[j]?.childawbnumber,
                                shipperaddressbookid: tempName[i]?.id,
                                shippername: tempName[i]?.name,
                                consigneeaddressbookid: tempName[i + 1]?.id,
                                consigneename: tempName[i + 1]?.name,
                                deliverymode: 'Split'
                            })
                        }
                        this.rowData = tempData;
                        this.isSplitGenerated = true;
                    }
                });
            }
        } catch (e) {
            console.error(e);
        }
    }

    onSaveClick() {
        try {
            this.isFormSubmitted = true;
            this.ngxLoaderService.start();
            if (this.awbSplitForm.valid) {
                this.awbService.SplitAwb({ awbnumber: this.AwbNumber, childawblist: this.rowData }).subscribe((res) => {
                    if (res?.success) {
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage('Record Save Successfully', 'Success', 'success');
                        this.activeModal.close('Record Save Successfully');
                    }
                })
            }
        } catch (err) {
            console.error("Err", err);
            this.appCoreService.showMessage('Internal Server Error', 'Error', 'error');
            this.ngxLoaderService.stop();
        }
    }
}
